import InputField from '@/components/common/InputField';
import { Text } from '@/components/common/Typography';
import { FlexProps, Skeleton, Spacer } from '@chakra-ui/react';
import { useRuleContext } from '@common/react/cashflow/rules';
import pluralize from '@common/util/pluralize';

const ApplyToCheckbox = (props: FlexProps) => {
    const {
        applyToAll,
        setApplyToAll,
        matchingTransactions,
        matchingTransactionsLoading,
        isGlobalRule,
    } = useRuleContext();

    if (matchingTransactionsLoading) {
        return <Skeleton h={5} w={200} />;
    }

    if (
        isGlobalRule ||
        (matchingTransactions && matchingTransactions.length > 0)
    ) {
        const label = isGlobalRule
            ? 'Apply to all users (dangerous)'
            : `Apply to ${pluralize('transaction', matchingTransactions?.length || 0, true)}`;
        return (
            <InputField
                label={label}
                type="checkbox"
                name="apply-to-transactions"
                inputProps={{ variant: 'flushed' }}
                onChange={setApplyToAll}
                value={applyToAll}
                {...props}
            />
        );
    }

    if (matchingTransactions && matchingTransactions.length === 0) {
        return <Text>No matching transactions</Text>;
    }

    return <Spacer />;
};

export default ApplyToCheckbox;
